import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Label,
  RadioGroup,
  RadioGroupItem,
} from '@ais-ui/ui-core'; // You'll need this too // Add these imports
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { StepperFooter } from './StepperFooter';
import { StepperHeadline } from './StepperHeadline';
import React, { useEffect, useMemo } from 'react';
import { useLocalization } from '@ais-ui/locale-management';
import { useCreateReportContext } from './CreateReportContext';
import {
  createReportTemplateShipFormSchema,
  reportTemplateShipValues,
} from '../utils/createShipsFormSchema';
import { MultiShipCommand } from '../../../utils/ShipCommand';

export const ShipStep = () => {
  const { messages } = useLocalization();

  const { stepperProps, setShips, ships, shipAttribute, setShipAttribute } =
    useCreateReportContext();

  const formSchema = useMemo(() => createReportTemplateShipFormSchema(), []);

  const form = useForm<reportTemplateShipValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      ships: [],
      attribute: 'filterBy',
    },
  });

  useEffect(() => {
    form.reset({
      ships: ships,
      attribute: shipAttribute,
    });
  }, [ships, shipAttribute, form]);

  const onPrevious = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    stepperProps.prevStep();
  };

  const onNext = (data: reportTemplateShipValues) => {
    setShips(data.ships);
    setShipAttribute(data.attribute);
    stepperProps.nextStep();
  };

  return (
    <>
      <StepperHeadline
        headerText={messages.reportsCreateReportShipTitle}
        subHeaderText={messages.reportsCreateReportShipSubtitle}
      ></StepperHeadline>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onNext)}
          className="flex flex-col space-y-8 pt-4 h-full flex-grow"
        >
          <div className="h-[85%]">
            <div className="space-y-6">
              <FormField
                control={form.control}
                name="ships"
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>
                      {messages.reportsCreateReportShipLabel}
                    </FormLabel>
                    <FormControl>
                      <MultiShipCommand
                        value={field.value}
                        onChange={field.onChange}
                      ></MultiShipCommand>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="attribute"
                render={({ field }) => (
                  <FormItem className="space-y-3">
                    <FormLabel>Attribute Type</FormLabel>
                    <FormControl>
                      <RadioGroup
                        onValueChange={field.onChange}
                        value={field.value}
                        className="flex flex-col space-y-2"
                      >
                        <div className="flex items-center space-x-2">
                          <RadioGroupItem value="filterBy" id="filterBy" />
                          <Label htmlFor="filterBy">Filter By</Label>
                        </div>
                        <div className="flex items-center space-x-2">
                          <RadioGroupItem value="colorBy" id="colorBy" />
                          <Label htmlFor="colorBy">Color By</Label>
                        </div>
                      </RadioGroup>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
          </div>
          <StepperFooter
            onPrevious={onPrevious}
            onNext={form.handleSubmit(onNext)}
            stepperProps={stepperProps}
          ></StepperFooter>
        </form>
      </Form>
    </>
  );
};
